import { useEffect, useState } from "react";
import { CheckoutDialog } from "./CartDialogs";
import { useSelector } from "react-redux";
import { getCart } from "../redux/selectors";
import { calculateOrderSummary } from "../data/helpers";
import { storeId } from "../data/constants";

export const CartSummary = ({ handleClose }) => {
  const [open, setOpen] = useState(false);

  const cartList = useSelector(getCart);
  const cartListTotalQty = cartList.reduce((acc, curr) => {
    return acc + curr.qty * 0.05;
  }, 0);

  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    setOrderData(calculateOrderSummary(cartList, storeId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId, cartList.length, cartListTotalQty]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseCheckout = () => {
    setOpen(false);
  };

  if (!orderData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="w-full my-2 pt-2 border-t-2 border-gray-300">
      <div className="w-full">
        <div className="w-full flex justify-between text-sm md:text-base">
          <p>Subtotal:</p>
          <p>${orderData.subtotal}</p>
        </div>
        {Number(orderData.taxGST) ? (
          <div className="w-full flex justify-between text-sm md:text-base text-gray-500">
            <p>GST:</p>
            <p>${orderData.taxGST}</p>
          </div>
        ) : null}
        {Number(orderData.taxPST) ? (
          <div className="w-full flex justify-between text-sm md:text-base text-gray-500">
            <p>PST:</p>
            <p>${orderData.taxPST}</p>
          </div>
        ) : null}
        <div className="w-full flex justify-between text-sm md:text-base text-gray-500">
          <p>Delivery:</p>
          <p>${orderData.delivery}</p>
        </div>
        <div className="w-full flex justify-between text-lg md:text-xl">
          <p>Total:</p>
          <p>${orderData.total}</p>
        </div>
        <p className="text-gray-500 mb-4 mt-2 text-center text-sm">
          The total cost is an estimate and will be confirmed by the shop before
          processing
        </p>
      </div>
      <div className="mt-2 w-full flex gap-4">
        <button
          onClick={handleClose}
          className="btn w-1/2 text-gray-400 border-gray-400  hover:border-mainBlack hover:text-mainBlack"
        >
          Back To Shop
        </button>
        <button
          onClick={() => {
            handleClose();
            handleClickOpen();
          }}
          className="btn w-1/2 border-mainBlack hover:border-mainRed hover:text-mainRed bg-mainGreen"
        >
          Checkout
        </button>
      </div>
      <CheckoutDialog open={open} handleCloseCheckout={handleCloseCheckout} />
    </div>
  );
};
